import PropTypes from 'prop-types'
import Access from '../context/Access'
import Maintenance from './Maintenance'

import { useAuthContext } from './AuthProvider'
import { useEffect } from 'react'

const AuthWall = ({ children }) => {
  const { isLoggedIn } = useAuthContext()

  useEffect(() => {
    if (window.location.pathname.startsWith('/home')) {
      const newPath = window.location.pathname.replace('/home', '') || '/'
      window.history.replaceState({}, '', newPath + window.location.search)
    }
  }, [])

  const IS_MAINTENANCE = process.env.REACT_APP_IS_MAINTENANCE

  return IS_MAINTENANCE === '1' ? (
    <Maintenance />
  ) : isLoggedIn ? (
    children
  ) : (
    <Access />
  )
}
AuthWall.propTypes = {
  children: PropTypes.element.isRequired,
}

export default AuthWall
